import { BusinessRuleType, EntityDefinition } from '../types/entity-definition.interface';
import { Unit } from '../types/unit.interface';

export const unitDefinition: EntityDefinition<Unit> = {
  entityType: 'Unit',
  i18nBase: 'entities.unit',
  enableFiltering: true,
  // UAT 27.07 #21 : la grille respecte l'ordre fourni (type d'unité puis nom), comme les listes de mesures.
  defaultSortField: null,
  list: {
    columns: [
      {
        field: 'name',
        headerKey: 'entities.unit.fields.name',
        sortable: true,
        filterable: true,
        class: 'min-w-[200px]',
        contentClass: 'line-clamp-1',
        showTooltip: true,
      },
      { field: 'symbol', headerKey: 'entities.unit.fields.symbol', sortable: true, filterable: true },
      {
        field: 'unitTypeId',
        headerKey: 'entities.unit.fields.unitType',
        sortable: true,
        filterable: 'select',
        storeType: 'UnitType',
        displayField: 'name',
      },
    ],
  },
  validationRules: [
    {
      type: BusinessRuleType.DELETE_VALIDATION,
      rule: (entity: Unit) => !entity.isUsed,
      errorMessageKey: 'entities.unit.messages.deleteError',
    },
  ],
  actionButtons: {
    parent: {
      add: true,
      edit: true,
    },
  },

  messages: {
    dialogTitles: {
      create: () => 'entities.unit.messages.createTitle',
      edit: () => 'entities.unit.messages.editTitleWithName',
      delete: () => 'common.confirmations.deleteTitleWithName',
    },
    buttons: {
      add: () => 'entities.unit.messages.addButton',
      create: () => 'entities.unit.messages.addButton',
      edit: () => 'entities.unit.messages.editTitleWithName',
      delete: () => 'entities.unit.messages.deleteTitle',
    },
    confirmDelete: () => 'entities.unit.messages.deleteConfirm',
  },
};
